const get_ids_for_string = (word: string): number[] => {
  if (!word) return []
  const result = word.match(/\d+/g)
  return result ? Array.from(new Set(result)).map((str) => Number(str)) : []
}

export default get_ids_for_string
